/** Marca o campo como _deleted em vez de remover; usado para histórico de métricas. Não é enviado ao flow. */
export const handleRemoveField = (
  fieldId: string,
  form: any,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const newItems = form.map((item: any) =>
    item.uuid === fieldId ? { ...item, _deleted: true } : item
  );
  setForm(newItems);
  setButtonSave(true);
};
